export const MerchantSelectionViewStyles = {
  title: 'text-28px text-blue700 mt-6 font-bold',
  description: 'text-18px text-blue700 mt-6 w-3/4',
  merchantsLocatorTitle: 'text-20px text-blue300 text-center mb-2',
  loadingContainer: 'flex flex-col justify-center',
  selectAssetSubtypeTitle: 'text-20px text-blue300 text-center mb-6',
}
